import { LoadingSizeLiterals } from './Loading.types';

export const TEST_ID_LOADING = 'testidLoading';

interface LoadingSizesShape {
  innerCircleWidth: string;
  innerCircleHeight: string;
  outerCircleWidth: string;
  outerCircleHeight: string;
  animationWidth: string;
  animationHeight: string;
}

export const LOADING_SIZES_MAP: Record<LoadingSizeLiterals, LoadingSizesShape> = {
  sm: {
    innerCircleWidth: '22.5px',
    innerCircleHeight: '22.5px',
    outerCircleWidth: '37.5px',
    outerCircleHeight: '37.5px',
    animationWidth: '30px',
    animationHeight: '30px',
  },
  md: {
    innerCircleWidth: '31.5px',
    innerCircleHeight: '31.5px',
    outerCircleWidth: '52.5px',
    outerCircleHeight: '52.5px',
    animationWidth: '42px',
    animationHeight: '42px',
  },
  lg: {
    innerCircleWidth: '45px',
    innerCircleHeight: '45px',
    outerCircleWidth: '75px',
    outerCircleHeight: '75px',
    animationWidth: '60px',
    animationHeight: '60px',
  },
};
